import type { BackendSuccessResponse } from "./api.types";
import type { CatalogueBulkApproveItemResult, CatalogueItemVersionID } from "./catalogue.types";

export enum ReviewStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
}

export interface PendingReview {
  reviewId: string;
  userId: string;
  vendorId: string;
  productId: string;
  orderId: string;
  productName: string;
  vendorName: string;
  userName: string;
  status: ReviewStatus;
  rating: number;
  images: string[];
  reviewText: string;
  reply?: string;
  reviewCreatedAt: string;
  replyCreatedAt?: string;
  replyUpdatedAt?: string;
  versionId: CatalogueItemVersionID; // Required for bulk approve
}

export type GetAllReviewsResponse = BackendSuccessResponse<{
  items: Array<PendingReview>;
  endCursor?: string;
}>;

export type ApproveReviewResponse = BackendSuccessResponse<PendingReview>;

export type DeclineReviewResponse = ApproveReviewResponse;

export type BulkApproveReviewsResponse = BackendSuccessResponse<{
  results: CatalogueBulkApproveItemResult<'reviewId', string>[]
}>
